import { HookError } from 'components/ErrorBoundary';
import { CustomerStateType, CustomerReducerActionType } from './types';
import { ACTIONS } from 'constants/hook';

export const initialState: CustomerStateType = {
  isLoggedIn: false,
  userInfo: {
    city: undefined,
    email: undefined,
    firstName: undefined,
    ipAddress: undefined,
    lastName: undefined,
    latitude: undefined,
    longitude: undefined,
    stateAbbreviation: undefined,
    zip5: undefined,
  },
};

export const customerReducer = (state: CustomerStateType, action: CustomerReducerActionType) => {
  switch (action.type) {
    case ACTIONS.INITIALIZE: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case ACTIONS.CHANGE: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case ACTIONS.RESET: {
      return initialState;
    }
    default: {
      throw new HookError(`Unhandled action type: ${action.type}`);
    }
  }
};
